export default __webpack_public_path__ + "static/media/question.abd4c6bb.svg";